import type { CreateRepresentativeInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateRepresentativeMutation } from '../hooks/use-representative-mutations'
import { RepresentativeForm } from './representative-form'

type RepresentativeCreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo representante" dentro del side panel: el mismo form que la edición. */
export function RepresentativeCreatePanel({ onDone }: RepresentativeCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateRepresentativeMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateRepresentativeInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <RepresentativeForm
      submitLabel="Crear representante"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
